import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { ReactNode } from "react";

interface CustomTabPanelProps  {
  children?: ReactNode;
}

export const CustomTabPanel = (props:CustomTabPanelProps) => {
  const { children, ...other } = props;

  return (
    <div
      role="tabpanel"
      // hidden={value !== index}
      // id={`simple-tabpanel-${index}`}
      // aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {/* {value === index && ( */}
      <Box sx={{ p: 3 }} style={{ padding: "0" }}>
        <Typography component={"span"}>{children}</Typography>
      </Box>
      {/* )} */}
    </div>
  );
};

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  // index: PropTypes.number.isRequired,
  // value: PropTypes.number.isRequired,
};
export default CustomTabPanel;
